import styled from 'styled-components';
import { ButtonStyleProps, ButtonVariant } from './Button.types';
import { ButtonWithResettedStyles } from '../../events/DetailsTab/DetailsTab.styles';

const handleButtonSize = ({ size }: Partial<ButtonStyleProps>) => {
  const sizeMatcher = {
    small: 'clamp(0.5rem, 3vw, 1.5rem)',
    medium: 'clamp(1rem, 4vw, 2rem)',
    large: 'clamp(1.5rem, 5vw, 6rem)',
    full: '0px',
  };

  return `${sizeMatcher[size!]}`;
};

export const StyledButton = styled(ButtonWithResettedStyles)<ButtonStyleProps>`
  height: 30px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  font-size: clamp(4px, 12px, 16px);
  font-family: Heebo;

  padding-left: ${handleButtonSize};
  padding-right: ${handleButtonSize};

  width: ${({ size }) => (size === 'full' ? '100%' : 'auto')};

  white-space: nowrap;
  border: ${({ variant, buttonColor }) =>
    variant === ButtonVariant.Outlined && `2px solid ${buttonColor}`};

  background-color: ${({ buttonColor, variant }) =>
    variant === ButtonVariant.Outlined ? 'transparent' : buttonColor};

  color: ${({ textColor }) => textColor};

  border-radius: 2px;

  transition: all 0.2s ease-in-out;

  &:disabled {
    cursor: not-allowed;
    background-color: #c1cdd7;
    color: black;
    border: none;
  }

  &:hover:not(:disabled) {
    cursor: pointer;
    filter: ${({ variant }) =>
      variant === ButtonVariant.Filled ? 'brightness(110%)' : 'none'};
    transform: scale(1.01);
    background-color: ${({ buttonColor }) => buttonColor};
    color: ${({ hoverTextColor }) => hoverTextColor};
  }
`;
